module.exports = "/_next/static/images/divorce-ny-logo-4855b46d61fd5b4873ac48ffe9cfb939.svg";